import { Component, OnInit } from '@angular/core';
import { Report, SelectionAction } from '../../../report/report';
import { FetchPostRequestService } from './fetch-post-request.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ChangePostStatusService } from './change-post-status.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-otlob-x-post-request',
  templateUrl: './otlob-x-post-request.component.html',
  styleUrls: ['./otlob-x-post-request.component.scss'],
})
export class OtlobXPostRequestComponent implements OnInit {
  constructor(
    public fetchPostRequest: FetchPostRequestService,
    private changePostStatusService: ChangePostStatusService
  ) {}

  tableColumns: string[] = [
    'id',
    'username',
    'userPhone',
    'title',
    'description',
    'status',
    'isPublic',
    'extraText',
    'price',
    'city',
    'governorate',
    'created_at',
  ];

  displayTableColumns = {
    id: '#Post ID',
    title: 'Title',
    description: 'Description',
    status: 'Status',
    isPublic: 'is Public',
    extraText: 'Extra Text',
    Price: 'Price',
    created_at: 'Created At',
    username: 'User Name',
    userPhone: 'User Phone',
    city: 'City',
    governorate: 'Governorate',
  };

  totalNumberOfRecords = 0;
  postData: any[] = [];
  requestBody: Report = {};
  loading = false;
  selectionModel = new SelectionModel<any>(true, []);

  selectionActions: SelectionAction[] = [
    {
      actionName: 'Rejected',
      actionValue: 'DECLINED',
      actionType: 'Button',
      actionClass: 'btn-outline-danger',
    },
    {
      actionName: 'Accepted',
      actionValue: 'ACCEPTED',
      actionType: 'Button',
      actionClass: 'btn-success',
    },
  ];

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize,
    };
    await this.updateTable();
    this.fetchPostRequest.loader().subscribe((val) => (this.loading = val));
  }

  async updateTable() {
    this.fetchPostRequest.setParams(this.requestBody);
    const report = await this.fetchPostRequest.make();
    this.postData = report.data.result;
    this.totalNumberOfRecords = report.data.totalNumberOfRows;
  }

  async selectionTrigger(event: any) {
    this.changePostStatusService.setParams({
      posts: this.prepareSelectionUpdateArray(event),
    });
    try {
      await this.changePostStatusService.make();
      this.selectionModel.clear();
      await this.updateTable();
      this.fetchPostRequest.loader().subscribe((val) => (this.loading = val));
    } catch (err) {
      this.showFailPopup(err.faultyRequest.error.message);
      console.log(err);
    }
  }

  async ngOnInit() {
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    this.updateTable();
    this.fetchPostRequest.loader().subscribe((val) => (this.loading = val));
  }

  prepareSelectionUpdateArray(event: any) {
    const action = event.action;
    const posts = event.selection.map((item) => ({
      id: item.id,
      approval_status: action,
    }));
    return posts;
  }

  showFailPopup(message: string = 'Something went wrong. Please try again') {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: message,
    });
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.fetchPostRequest.loader().subscribe(val => (this.loading = val));
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.fetchPostRequest.loader().subscribe(val => (this.loading = val));
    }
    this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.fetchPostRequest.loader().subscribe(val => (this.loading = val));
  }
}
